module.exports = __webpack_public_path__ + "static/media/warning.bee9308f.svg";